import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule, } from '@angular/material/input';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatTooltipModule, TooltipPosition } from '@angular/material/tooltip';


@Component({
  selector: 'so-date-picker',
  templateUrl: './so-date-picker.component.html',
  styleUrls: ['./so-date-picker.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatTooltipModule,
    ReactiveFormsModule
  ]
})
export class SoDatePickerComponent {
  @Input() formCtrl: FormControl;
  @Input() placeHolder = "Please enter a date.";
  @Input() disableClearBtn = false;
  @Input() errormessage = "Entry is invalid.";
  @Input() label = "Label Not set.";
  @Input() tooltip = "";
  @Input() tooltipPosition: TooltipPosition = "above";
  @Input() minDate: Date;
  @Input() maxDate: Date;
  @Output() changeEvent = new EventEmitter<string[]>();

  /*
  is this needed?  The parent could subscribe to a form control change.
  */
  emitChange() {
    this.changeEvent.emit(this.formCtrl.value);
  }
  clearControl() {
    this.formCtrl.setValue(null);
    this.changeEvent.emit(this.formCtrl.value);
  }

}
